import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { switchOrg } from 'services/auth';
import { useDispatch } from 'react-redux';
import { AUTH_ACTIONS } from 'config';
import { useNavigate } from "react-router";
import { setUserType } from 'store/actions/zignaAi';

export default function SwitchOrg() {
    const { orgs, currentOrg } = useSelector(state => state.auth)

    const dispatch = useDispatch()
    const navigate = useNavigate()

  const getOrgsFromRoles = (roles) => {
    let orgs = []
    roles.map(p => {
      if (!orgs.find(o => o.id === p.organization_id))
        orgs.push({ id: p.organization_id, name: p.company_name })
    })
    return orgs;
  }

  const switchModule = (module, permission) => {

    const redirectMapping = {
      professional: '/v1/',
      ancillary: '/',
      facility: '/',
      dataAuditReport: '/payer-scorecard'
    };

    const selectedUserType = module;
    if (!selectedUserType) return;

    localStorage.setItem('userType', selectedUserType);
    dispatch(setUserType({ userType: selectedUserType }));

    const hasPermission = permission.some(
      (item) => item.module === selectedUserType && (selectedUserType === 'dataAuditReport' || item.perm_name === 'competitive_landscape')
    );

    if (hasPermission) {
      window.location.href = redirectMapping[selectedUserType];
    } else {
      navigate('/maintenance/404');
    }
  };

  const handleSwitch = (organization) => {
    dispatch({
      type: AUTH_ACTIONS.UPDATE_AUTH,
      payload: {
        loading: true
      }
    })
    switchOrg({ organization_id: organization.id })
      .then(res => {
        dispatch({
          type: AUTH_ACTIONS.UPDATE_AUTH,
          payload: {
            permission: res.data.permissions,
            roles: res.data.roles,
            orgs: getOrgsFromRoles(res.data.roles),
            currentOrg: organization
          }
        })
        window.localStorage.setItem('serviceToken', res.data.serviceToken);
        window.localStorage.setItem('currentOrg', JSON.stringify(currentOrg))
        const randomModule = res?.data?.permissions[0]?.module
        setTimeout(()=>{
          switchModule(randomModule, res.data.permissions || [])
        })
      })
      .catch(err => {
        console.log(err)
      })
      .finally(()=>{
        dispatch({
          type: AUTH_ACTIONS.UPDATE_AUTH,
          payload: {
            loading: false
          }
        })
      })
  }

    return (
        <Box width={"100%"} height={"100vh"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Box width={"fit-content"} display={"flex"} flexDirection={"column"} gap={2}>
                <Typography variant="h3" marginBottom={2}>Switch your Organization</Typography>
                {
                    orgs.map((org, index)=>(
                        <Button key={index} fullWidth variant="outlined" onClick={()=>handleSwitch(org)}>
                            {org.name}{org.id==currentOrg.id ? <span>&nbsp;( active )</span>: ''}
                            </Button>
                    ))
                }
            </Box>
        </Box>
    )
}